import { render, staticRenderFns } from "./customer-access-rights.vue?vue&type=template&id=bbdfacb4&"
import script from "./customer-access-rights.vue?vue&type=script&lang=js&"
export * from "./customer-access-rights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports